export default __webpack_public_path__ + "static/media/component003Student-right.e6fa4af6.svg";